import React from 'react';
import { HeroVariant75 } from '../components/HeroVariant75';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage75() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1822">
      <Navigation data-id="element-1823" />
      <main data-id="element-1824">
        <HeroVariant75 data-id="element-1825" />
        <WhyUs data-id="element-1826" />
        <Services data-id="element-1827" />
        <FAQ data-id="element-1828" />
        <Testimonials data-id="element-1829" />
        <Consultation data-id="element-1830" />
      </main>
      <Footer data-id="element-1831" />
      <CookieBanner data-id="element-1832" />
      <FloatingContact data-id="element-1833" />
    </div>;
}